import React, { Component } from 'react';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { MenuComponent } from '../MenuComponent';
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../GlobalContext';
import * as MySound from '../MySound';

export class LH_PutArray extends Component {
    static displayName = LH_PutArray.name;

    constructor(props) {
        super(props);
        this.history = props.history;
        this.state = {
            alertMessage: "",
            locationArray: [],
            putawayLocation: "",
            selectedContainerRef: "",
            searchedDebtor: "",
            searchedCustPO: "",
            searchedCartons: "",
            searchedCartonType: "",
            selectedDebtor: "",
            selectedCustPO: "",
            selectedCartons: "",
            selectedCartonType: ""

        }
    }

    componentDidMount() {
        if (this.props.location && this.props.location.state) {
            this.setState({ selectedContainerRef: this.props.location.state.selectedContainerRef });
            const selectedContainerRef = this.props.location.state.selectedContainerRef;
            if (selectedContainerRef && selectedContainerRef !== "") {

                this.loadLocationArray(selectedContainerRef);
                this.refs.putawayLocationInput.focus();
            }

        }

    }

    goto(page) {
        this.history.push({
            pathname: page,
            state: this.state
        });
    }

    async loadLocationArray(selectedContainerRef) {

        this.state.loading = true;
        fetch(`api/LinenhouseXdoc/GetLocationArrayResult?containerRef=${selectedContainerRef}`)
            .then(async response => {

                this.state.loading = false;
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    this.setState({ locationArray: [], alertMessage: errorText });
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;

                    if (apiResponse) {
                        const data = apiResponse.data;
                        if (apiResponse.success) {
                            this.setState({ locationArray: data, alertMessage: "" });
                            if (this.state.locationArray && this.state.locationArray.length > 0) {
                                this.selectItem(this.state.locationArray[0]);
                            }
                          
                        }
                        else {
                            if (apiResponse.errorMessage && apiResponse.errorMessage.trim() == "No data Found") {
                                this.goto('../LinenhouseXdoc/LH_Rows');
                            }
                            else {
                                this.setState({ alertMessage: "Failed to load Location Array!!  " + apiResponse.errorMessage });
                            }
                        }
                    }
                    else {
                        this.setState({ alertMessage: "Failed to load Location Array!!" });
                    }
                }

            })
            .catch(error => {
                this.setState({ openASN: [], alertMessage: error });
            });
    }

    setLocation() {
        this.setState({ alertMessage: "" });

        if (!this.state.selectedContainerRef || this.state.selectedContainerRef == "") {
            this.setState({ alertMessage: "Container Number cannot be loaded" });
            return;
        }
        if (!this.state.putawayLocation || this.state.putawayLocation == "") {
            this.setState({ alertMessage: "Please enter a valid location" });
            this.refs.putawayLocationInput.focus();
            return;
        }

        this.state.putawayLocation = this.state.putawayLocation.trim();
        var barCodeFormat = this.state.putawayLocation.split("-");
        if (!barCodeFormat || barCodeFormat.length !== 4) {
            this.setState({ loading: false, putawayLocation: "", alertMessage: "Invalid Location!! Location should be of this format : Stage-01-01-09" });
            this.refs.putawayLocationInput.focus();
            return;
        }


        var lh_SetLocationRequest = {
            containerref: this.state.selectedContainerRef,
            customerPO: this.state.selectedCustPO,
            debtor: this.state.selectedDebtor,
            cartonType: this.state.selectedCartonType,
            putawayloc: this.state.putawayLocation
        };
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(lh_SetLocationRequest)
        };

        fetch(`api/LinenhouseXdoc/SetLocation`, requestOptions)
            .then(async response => {

                this.setState({ loading: false });
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    this.setState({ alertMessage: errorText });
                    return;
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;
                    if (apiResponse) {
                        if (apiResponse.success && apiResponse.data === true) {

                          
                            this.setState({
                                alertMessage: "Put away location updated!!",
                                putawayLocation: "",
                                selectedDebtor: "",
                                selectedCustPO: "",
                                selectedCartons: "",
                                selectedCartonType: ""
                               
                            });

                            if (this.state.selectedContainerRef && this.state.selectedContainerRef !== "") {
                                this.loadLocationArray(this.state.selectedContainerRef);
                                MySound.play(MySound.Sound.next);
                            }
                           
                        }
                        else {
                                MySound.play(MySound.Sound.stop);
                                //TODO: Check with Bruce about the wording of this message
                                this.setState({ alertMessage: "Failed to update Put away location!!  " + apiResponse.errorMessage });
                        }
                    }
                    else {
                            MySound.play(MySound.Sound.stop);
                            this.setState({ alertMessage: "Failed to update Put away location!!" });
                    }
                }
            })
            .catch(error => {
                this.setState({ alertMessage: error });
            });

     
    }

    selectItem(selectedRow) {
        this.setState({
            selectedDebtor: selectedRow.debtor,
            selectedCustPO: selectedRow.custPO,
            selectedCartons: selectedRow.cartons,
            selectedCartonType: selectedRow.cartonType,
        });
        
    }

    render() {

        let locationArrayHtml = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderLocationArray();

        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <MyAlert variant="danger">{alertMessage}</MyAlert> : "";

        const handlePutawayLocationInputKeyPress = e => {
            if (e.keyCode === 13 || e.charCode === 13 || e.which === 13) {
                this.setLocation();
            }
        };

        return (
            <div>
                <Container>
                    <Row className="mb-3">
                        <Col xs={9}><h4>Create Put Array</h4></Col>
                        <Col xs={3}><button type="button" className="btn btn-success col-12 mb-2" onClick={() => { this.goto('../LinenhouseXdoc/LH_LoadOpenASN'); }} >
                            Back
                        </button></Col>
                    </Row>
                    <Row>
                        <Col>{alertMessage}</Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={3}>Store : </Col>
                        <Col xs={7}>{this.state.selectedDebtor}</Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={3}>Cartons : </Col>
                        <Col xs={7}>{this.state.selectedCartons}</Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={3}>Type : </Col>
                        <Col xs={7}>{this.state.selectedCartonType}</Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={3}>Scan Array Location</Col>
                        <Col xs={7}><input ref="putawayLocationInput" className="form-control" placeholder="Stage-1-1-1" value={this.state.putawayLocation}
                            onChange={(e) => {
                                this.setState({ putawayLocation: e.target.value });
                            }} onKeyPress={handlePutawayLocationInputKeyPress} readOnly={this.state.loading} >
                        </input></Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="tableHolder hm-50vh mb-3">
                                {locationArrayHtml}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

        );
    }

    renderLocationArray() {

        return (
            <div>
                <table className='table table-striped' aria-labelledby="tabelLabel">
                    <thead style={{ position: 'sticky', top: -2, background: 'white' }}>
                        <tr>
                            <th className="col-sm-4">
                                <label>Store</label>
                                <br />
                                <input className="col-sm-4" ref="containerRefInput" value={this.state.searchedDebtor} onChange={(e) => { this.setState({ searchedDebtor: e.target.value }); }} />
                            </th>
                            <th className="col-sm-4">
                                <label>PO</label>
                                <br />
                                <input className="col-sm-4" ref="containerRefInput" value={this.state.searchedCustPO} onChange={(e) => { this.setState({ searchedCustPO: e.target.value }); }} />
                            </th>
                            <th className="col-sm-4">
                                <label>Cartons</label>
                                <br />
                                <input className="col-sm-4" ref="containerRefInput" value={this.state.searchedCartons} onChange={(e) => { this.setState({ searchedCartons: e.target.value }); }} />
                            </th>
                            <th className="col-sm-4">
                                <label>CartonType</label>
                                <br />
                                <input className="col-sm-4" ref="containerRefInput" value={this.state.searchedCartonType} onChange={(e) => { this.setState({ searchedCartonType: e.target.value }); }} />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.locationArray
                            .filter((item) =>

                                (!this.state.searchedDebtor.length ||
                                    item.debtor
                                        .toString()
                                        .toLowerCase()
                                        .includes(this.state.searchedDebtor.toString().toLowerCase())) &&
                                (!this.state.searchedCustPO.length ||
                                    item.custPO
                                        .toString()
                                        .toLowerCase()
                                        .includes(this.state.searchedCustPO.toString().toLowerCase())) &&
                                (!this.state.searchedCartons.length ||
                                    item.cartons
                                        .toString()
                                        .toLowerCase()
                                        .includes(this.state.searchedCartons.toString().toLowerCase())) &&
                                (!this.state.searchedCartonType.length ||
                                    item.cartonType
                                        .toString()
                                        .toLowerCase()
                                        .includes(this.state.searchedCartonType.toString().toLowerCase()))
                            ).map((row, index) =>
                                <tr key={index} onClick={() => { this.selectItem(row) }}>
                                    <td>{row.debtor}</td>
                                    <td>{row.custPO}</td>
                                    <td>{row.cartons}</td>
                                    <td>{row.cartonType}</td>
                                </tr>
                            )}
                    </tbody>
                </table>
            </div>
        );
    }

}
